import { RegularBenefit, RegularBenefitVariant } from '../../../../../typings'
import { FormulaReview } from './Formula'
import { FreeShippingReview } from './FreeShipping'
import { GiftReview } from './Gift'
import { MaxPriceReview } from './MaxPrice'
import { MaxShippingReview } from './MaxShipping'
import { NominalLoyaltyReview } from './NominalLoyalty'
import { NominalPriceReview } from './NominalPrice'
import { NominalShippingReview } from './NominalShipping'
import { PercentualLoyaltyReview } from './PercentualLoyalty'
import { PercentualPriceReview } from './PercentualPrice'
import { PercentualShippingReview } from './PercentualShipping'
import { PriceTableReview } from './PriceTable'

export type ReviewProps = {
  config: RegularBenefit
}

export const REVIEW_MAP: Record<
  RegularBenefitVariant,
  (props: ReviewProps) => JSX.Element
> = {
  [RegularBenefitVariant.Nominal]: NominalPriceReview,
  [RegularBenefitVariant.NominalShipping]: NominalShippingReview,
  [RegularBenefitVariant.Percentual]: PercentualPriceReview,
  [RegularBenefitVariant.MaxPrice]: MaxPriceReview,
  [RegularBenefitVariant.MaxShipping]: MaxShippingReview,
  [RegularBenefitVariant.FreeShipping]: FreeShippingReview,
  [RegularBenefitVariant.PercentualShipping]: PercentualShippingReview,
  [RegularBenefitVariant.NominalLoyalty]: NominalLoyaltyReview,
  [RegularBenefitVariant.Gift]: GiftReview,
  [RegularBenefitVariant.PercentualLoyalty]: PercentualLoyaltyReview,
  [RegularBenefitVariant.Formula]: FormulaReview,
  [RegularBenefitVariant.PriceTable]: PriceTableReview,
}
